export const numberConvertable = (value: unknown) => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'number') return true;
  if (typeof value === 'string') {
    const num = Number(value);
    if (Number.isNaN(num)) return false;
    return true;
  }
  return false;
};
